export const TYPES = {
  REFURBISHED: 'refurbished',
  ACCESSORY: 'accessory',
}
